import React from 'react';
import { connect } from 'react-redux';

class MenuItemChoice extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div>
                <div className="section-title">
                    <p className="selectionTitleText">{this.props.children}</p>
                </div>

                <div className="menu-item-choice-selection-window">
                    {this.props.choice.selections.map((selection) => {
                        if (this.props.choice.is_multiple) {
                            return (
                                <div key={selection.id} className="menu-item-choice-window">
                                    <label className="container" for={"selection-"+selection.id}>
                                        {(parseFloat(selection.price) > 0) ? selection.name + " - " + selection.price : selection.name}
                                        <input 
                                            type="checkbox"
                                            onClick={() => { 
                                                this.props.updateMultipleChoiceSelection(this.props.choice.id, this.props.choice.selections, this.props.cartItem.choices, selection);
                                            }}
                                            checked={this.props.isMultipleSelected(this.props.choice.id, selection.id)}
                                            id={"selection-"+selection.id}
                                        />
                                       <span className="checkmark"></span>
                                    </label>
                                </div>
                            );
                        } else {
                            return (     
                                <div key={selection.id} className="menu-item-choice-window">
                                    <label className="container" for={"selection-"+selection.id}>{(parseFloat(selection.price) > 0) ? selection.name + " - " + selection.price : selection.name}
                                    <input 
                                        type="checkbox"
                                        onClick={() => { 
                                            this.props.updateSingleChoiceSelection(this.props.choice.id, selection);
                                        }}
                                        checked={this.props.isSelected(this.props.choice.id, selection.id)}
                                        id={"selection-"+selection.id}
                                    />
                                    
                                    <span className="radio-checkmark"></span>
                                    </label>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        quantity: state.cartItem.quantity
    };
};

export default connect(mapStateToProps)(MenuItemChoice);